(function ($, app) {
	'use strict';

	$(window).on('pageNavigation', init);

	function init() {
	    $('.country-selector').combobox();
	}
}(jQuery, window.app));